export const selectedLocationStorageKey = 'lmo-selected-location'

export const setSelectedLocation = (value: string): void =>
  globalThis.localStorage?.setItem(selectedLocationStorageKey, value)

export const getSelectedLocation = (): string | null =>
  globalThis.localStorage?.getItem(selectedLocationStorageKey)
